<template>
  <div class="">
    <panel
      class="no-print"
      Title="ارسال فایل و مدارک"
      Des="از طریق این فرم میتوانید فایل های خواسته شده را برای مدیر سامانه ارسال نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-upload ml-3"></i>ارسال فایل و مدارک
          <span class="float-left" @click="$router.go(-1)">
            <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-light Pointer" style="float: left; font-size: 18px"></i
          ></span>
        </h6>
      </template>
      <template slot="content">
        <div class="bg-Custom text-center mt-2 rounded py-3 px-3" id="SendFile">
          <span v-if="!fileinfo.size && !fileinfo.name"> لطفا فایل مورد نظر خود را بارگذاری نمایید </span>
          <input type="file" @change="changefile($event)" class="d-none" :key="RenderFile" id="Uploader" accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf" />
          <button v-if="!fileinfo.size && !fileinfo.name" class="btn NetPa-btn btn-success mx-3" @click="clickUploader">بارگـــــذاری</button>
          <span v-if="fileinfo.size" class=""> حجم فایل : </span>
          <span v-if="fileinfo.size" class="font-weight-bold"> {{ (fileinfo.size / 1000000).toFixed(2) }} مگابایت</span>
          <span v-if="fileinfo.name" class="mr-3"> مشخصات فایل : </span>
          <span v-if="fileinfo.name" class="font-weight-bold"> {{ fileinfo.name }} </span>
          <span v-if="fileinfo.name" class="mr-5"> عنوان فایل : </span>
          <input v-if="fileinfo.size && fileinfo.name" type="text" class="form-control w-25 d-inline required" v-model="OnvanFile" @input="CheckValue($event)">
          <button v-if="fileinfo.size && fileinfo.name" class="btn NetPa-btn btn-outline-success mr-3" @click="SendFileforAdmin"><i class="fa fa-upload ml-3"></i> ارسال فایل</button>
          <button v-if="fileinfo.size && fileinfo.name" class="btn NetPa-btn btn-outline-danger mr-1" @click="Cancel"><i class="fa fa-times ml-3"></i> انصراف</button>
        </div>
        <div class="mt-3">
          <ListAzaFile :key="RenderFile" :ShowHeader="false" :IsAdmin="false" :wwwtblAzaId="AzaId"></ListAzaFile>
        </div>
      </template>
    </net-pa-card>
    <loading v-if="Loading"></loading>
  </div>
</template>
<script>
import Loading from '../Tools/NetPa/Loading.vue';
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import ListAzaFile from "./ListAzaFile.vue";
export default {
  components: { Panel, NetPaCard, ListAzaFile, Loading },
  data() {
    return {
      fileinfo: {},
      RenderFile: 0,
      AzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
      Loading:false,
      Render:0,
      OnvanFile:null,
      NotSend:true
    };
  },
  methods: {
    clickUploader() {
      document.getElementById("Uploader").click();
    },
    changefile(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = ["gif", "jpg", "jpeg", "png", "zip", "rar", "pdf"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost("فرمت فایل مجاز نیست", `فرمت ${fileExtension} پشتیبانی نمی‌شود.`, "error", 3000);
        e.target.value = "";
        return;
      }
      if (document.getElementById("Uploader").files[0].size > 1024 * 1024 * 5) {
        this.$mySweetDefaultTost("عملیات ناموفق", "  حجم فایل ارسالی بیشتر از 5 مگابایت است ", "error", 3000);
        this.fileinfo = {};
        this.RenderFile++;
        return;
      } else {
        this.fileinfo = document.getElementById("Uploader").files[0];
      }
    },
    SendFileforAdmin() {
      if (!this.$ValidForm('SendFile')) {
        return;
      }
      if (this.NotSend==true) {
        this.$mySweetDefaultTost('ورودی نا معتبر', 'وارد کردن عنوان فایل الزامی می باشد ', 'error', 1200)
        return
      }
      this.$SweetQustion(
        "اطمینان از ارسال فایل ",
        "از ارسال فایل خود اطمینان دارید؟ در صورت ارسال ، ویرایش فایل امکان پذیر نیست",
        "question",
        "تایید ",
        "انصراف",
        this.fileinfo,
        this.SendFile,
        this.isNotConfirmed
      );
    },
    Cancel() {
      this.fileinfo = {};
      this.RenderFile++;
    },
    SendFile() {
      this.Loading = true;
      let DataAxiosUpload = {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/SaveAttachmentToDb",
        Token: "",
      };
      var formdata = new FormData();
      formdata.append("IdEftetah", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      formdata.append("Image", this.fileinfo);
      formdata.append("TableName", "FileToAdmin");
      formdata.append("wwwtblcomboidgrp328", null);
      formdata.append("FileTitle", this.OnvanFile);
      DataAxiosUpload.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosUpload).then((data) => {
        // console.log("🤦🏻‍♂️ ~ file: SendFileToAdmin.vue:75 ~ data:", data)
        this.Loading = false;
        if (data.status == "Ok") {
          this.$mySweetDefault("ارسال موفق", "فایل شما با موفقیت برای مدیر سامانه ارسال گردید", "success", 2000);
        } else {
          this.$mySweetDefault("ارسال ناموفق", "فایل شما ارسال نشد  لطفا دقایق دیگر تلاش کنید", "danger", 2000);
        }
        this.Cancel();
      });
    },
    isNotConfirmed(){},
    CheckValue(ev){
      if (ev.target.value.trim().length==0) {
        ev.target.classList.add('wronginput')
        ev.target.focus()
        this.NotSend=true
        this.$mySweetDefaultTost('ورودی نا معتبر', 'فیلد مشخص شده الزامی می باشد ', 'error', 1200)
      }
      else{
        this.NotSend=false
        ev.target.classList.remove('wronginput')
      }
    }
  },
};
</script>
<style scoped>
.bg-Custom {
  background: #d3d3d3 !important;
  /* border:1px solid #2A3F54 !important; */
}
</style>
